import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { axios } from 'ApiClient';
import {
  ButtonToolbar,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
  FormGroup,
} from 'reactstrap';
import { CKEditor } from 'ckeditor4-react';

const NotesModal = ({
  isOpen,
  closeFunc,
  setVersion,
  prospect,
}) => {
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (isOpen && prospect) {
      setNotes(prospect.params?.brandNotes || '');
    }
  }, [isOpen]);

  const handleInputChange = (e) => {
    const { editor } = e;
    setNotes(editor.getData());
  };

  const submit = async () => {
    setLoading(true);
    try {
      await axios.post('/api/brand/prospects/post-update-cpm-prospect-property', {
        ids: [prospect.id],
        values: {
          brandNotes: notes,
        },
      });
      setLoading(false);
      setVersion((new Date()).toString());
      setNotes('');
      closeFunc();
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
    return true;
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => { setNotes(''); closeFunc(); }}
      style={{ minWidth: '670px' }}
    >
      <ModalHeader
        toggle={() => {
          setNotes('');
          closeFunc();
        }}
        tag="h4"
        className="modal-title-statistics pl-0"
      >
        Brand Notes
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            {prospect && (
              <FormGroup>
                <CKEditor
                  config={{ versionCheck: false }}
                  id="bodyEditor"
                  name="itemText"
                  activeClass="form-control"
                  initData={prospect.params?.brandNotes || ''}
                  onChange={(e) => { handleInputChange(e); }}
                />
              </FormGroup>
            )}
          </Col>
        </Row>
      </ModalBody>
      <ButtonToolbar className="modal__footer">
        <Button className="modal_ok btn-sm" color="primary" onClick={submit} disabled={loading} style={{ marginRight: '10px' }}>
          {loading && <span><div className="spinner-border text-light spinner-border-sm" />  </span>}
          <span>Save</span>
        </Button>
        <Button className="modal_cancel btn-sm" onClick={() => { setNotes(''); closeFunc(); }}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
};


NotesModal.propTypes = {
  closeFunc: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  prospect: PropTypes.objectOf(PropTypes.any).isRequired,
  setVersion: PropTypes.func.isRequired,
};

export default NotesModal;
